import { Fieldset, Grid } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconUsersGroup } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';
import { FormGenericSelector } from '../../../components/form/FormGenericSelector';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

type BulkUpdateProductFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
};

export function BulkUpdateProductForm({ form }: BulkUpdateProductFormProps) {
	const { organisation } = useParams();

	return (
		<>
			<Fieldset legend={'Product Information'}>
				<Grid>
					<Grid.Col span={12}>
						<FormGenericSelector
							label={'Group'}
							placeholder={'Leave blank to keep existing group...'}
							icon={<IconUsersGroup {...defaultIconStyle} />}
							form={form}
							property={'groupId'}
							apiRoute={`${organisation}/groups/options`}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<FormGenericSelector
							label={'Department'}
							placeholder={'Leave blank to keep existing department...'}
							icon={<IconUsersGroup {...defaultIconStyle} />}
							form={form}
							property={'departmentId'}
							apiRoute={`${organisation}/departments/options`}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<FormGenericSelector
							label={'Supplier'}
							placeholder={'Leave blank to keep existing supplier...'}
							icon={<IconUsersGroup {...defaultIconStyle} />}
							form={form}
							property={'supplierId'}
							apiRoute={`${organisation}/supplier/options`}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<FormGenericSelector
							label={'VAT Rate'}
							placeholder={'Leave blank to keep existing VAT rate...'}
							icon={<IconUsersGroup {...defaultIconStyle} />}
							form={form}
							property={'vatRateId'}
							apiRoute={`${organisation}/vat-rates/options`}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
